/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createCombinationsWithRep } from '../../factoriesAny.js';
export var combinationsWithRepDependencies = {
  typedDependencies: typedDependencies,
  createCombinationsWithRep: createCombinationsWithRep
};